// Permission check helpers — extracted from legacy-utils.ts

import { currentUserHasPermission, getCurrentUserId } from './auth';

const _w = window as any;

export function canCurrentUserAccessAnyClosedCalls(): boolean {
  return (currentUserHasPermission(_w.AccessAuthorities.ROLE_VIEW_OWN_CLOSED_CALL_CARDS) || currentUserHasPermission(_w.AccessAuthorities.ROLE_VIEW_OTHER_USERS_CLOSED_CALL_CARDS));
}

export function canCurrentUserAccessAnyApprovedCaseReports(): boolean {
  return (currentUserHasPermission(_w.AccessAuthorities.ROLE_VIEW_OWN_APPROVED_CASE_REPORTS) || currentUserHasPermission(_w.AccessAuthorities.ROLE_VIEW_OTHER_USERS_APPROVED_CASE_REPORTS));
}

export function canCurrentUserAccessCaseReport(authorId: number): boolean {
  return ((getCurrentUserId() === authorId && currentUserHasPermission(_w.AccessAuthorities.ROLE_VIEW_OWN_APPROVED_CASE_REPORTS)) ||
    (getCurrentUserId() !== authorId && currentUserHasPermission(_w.AccessAuthorities.ROLE_VIEW_OTHER_USERS_APPROVED_CASE_REPORTS)));
}
